import React, { useCallback, useContext, useEffect, useState } from "react";
import Highlighter from "react-highlight-words";
import AgGrid from "../../framework/AgGrid";
import { rowDown, rowUp } from "../../utils/gridUtils";
import GlobalContext from "../../framework/GlobalContext";
import { getH1NRXLabel } from "../../utils/constant";
import { displayToast } from "../../framework/toast/toastUtils";

const ProductSearchGrid = React.forwardRef((props, ref) => {
  const {
    searchTerm,
    rowData,
    selectionChanged = () => {},
    medicineSelected = () => {},
    showBatchSearch = () => {},
    showSubstituteSearch = () => {},
    showAddBatch,
    batchRowData,
    onEscape = () => {},
    showCurrentStock = false,
  } = props;
  const { currentComponent } = useContext(GlobalContext);
  const defaultColDef = {
    cellStyle: {
      color: "black",
      fontSize: "13px",
      fontWeight: 400,
    },
  };
  const medicineColumnDefs = [
    {
      headerName: "Product",
      minWidth: 400,
      field: "medicineNameDetailed",
      cellRendererFramework: (params) => {
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div
              className={`h1NrxLabel ${getH1NRXLabel(
                params.data.isTB ? "TB" : params.data.genericType
              )}`}
            >
              {getH1NRXLabel(params.data.isTB ? "TB" : params.data.genericType)}
            </div>
            <Highlighter
              highlightStyle={{
                backgroundColor: params?.node?.selected ? "white" : "#FDCE57",
                borderRadius: 4,
                //QA Feedback
              }}
              searchWords={searchTerm?.trim().split(new RegExp(/[^A-Za-z0-9]/))}
              autoEscape={true}
              textToHighlight={params?.value}
            />
          </div>
        );
      },
    },
    // { headerName: "Margin%", field: "marginPer" },
    // { headerName: "Stock", field: "currQuantity", hide: !showCurrentStock },
    // { headerName: "Loose", field: "currLoose", hide: !showCurrentStock },
    // { headerName: "Rack", field: "rack" },
    // { headerName: "Expiry", field: "expiry" },
    // {
    //   headerName: "MRP ₹",
    //   field: "mrp",
    //   valueFormatter: (params) => params.value?.toFixed(2),
    // },
  ];
  const [gridApi, setGridApi] = useState(null);
  const medicineSearchKeyupListener = useCallback(
    (event) => {
      const key = event.key?.toLowerCase();
      const ctrlKey = event.ctrlKey;
      const altKey = event.altKey;
      if (key === "arrowdown") {
        rowDown(gridApi);
        return;
      }
      if (key === "arrowup") {
        rowUp(gridApi);
        return;
      }
      if (key === "arrowright") {
        showBatchSearch(true);
        return;
      }
      if (key === "enter") {
        if (batchRowData?.length === 0) {
          showAddBatch(true);
        } else {
          medicineSelected();
        }
        return;
      }
      if (key === "escape") {
        onEscape();
        return;
      }
    },
    [
      batchRowData,
      gridApi,
      medicineSelected,
      onEscape,
      showAddBatch,
      showBatchSearch,
      showSubstituteSearch,
    ]
  );
  useEffect(() => {
    if (currentComponent === "grid_medicine_search") {
      document.addEventListener("keyup", medicineSearchKeyupListener, false);
    }
    return () => {
      document.removeEventListener("keyup", medicineSearchKeyupListener, false);
    };
  }, [medicineSearchKeyupListener, currentComponent]);
  return (
    <AgGrid
      ref={ref}
      columnDefs={medicineColumnDefs}
      defaultColDef={defaultColDef}
      onGridReady={(params) => {
        setGridApi(params.api);
        params.api.sizeColumnsToFit();
      }}
      onRowDataChanged={(params) => {
        if (params.api.getDisplayedRowCount() > 0) {
          params?.api?.getRowNode(0)?.setSelected(true);
          return;
        }
      }}
      onSelectionChanged={selectionChanged}
      rowData={rowData}
    />
  );
});
export default ProductSearchGrid;
